module.exports = __webpack_public_path__ + "static/media/jakarta-barat.3eb5bf21.svg";